import React, { useState, useRef, useEffect } from 'react'; 
import Select, { StylesConfig } from 'react-select'; 
import { useTranslation } from 'react-i18next';
 

const InsuranceDropdown = ({defaultItem , onChangeItem, isDisabled, onCloseEditInsurance}) => {
  const {t} = useTranslation();

  const [selectedOption, setSelectedOption] = useState(0);

  const insurances = [
    { id: 1, name: t('MustBeInsured'), color: "#ccc" },
    { id: 2, name: t('Insured'), color: "#16a085" },
    { id: 3, name:  t('NotInsured'), color: "#d80228" },  
  ];

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption.value);
    onChangeItem(selectedOption.value); 
    onCloseEditInsurance()
  };

  const handleMenuClose = () => {
    onCloseEditInsurance()

    };


  useEffect(() => {
    setSelectedOption(defaultItem)
  }, [defaultItem])

  const options = insurances.map((status) => ({ value: status.id, label: status.name ,  color: status.color}));


  const dot = (color = 'transparent') => ({
    alignItems: 'center',
    color: 'var(--text-color)', 
    display: 'flex', 
    ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 4,
      minHeight: 10,
      minWidth: 10,
    },
  });
  

  const colourStyles = {

    control: (provided, state) => ({
      ...provided,
       backgroundColor: 'white', 
       border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)',  
       boxShadow: state.isFocused ? 'none' : 'none', 
       '&:hover': {
         border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)', // Apply blue border on hover if focused, otherwise regular border
       }, 
       minHeight: "unset", 
       width: '115px',
       height: '22px',
       cursor: 'pointer',    
       borderRadius: '5px',  
    }),


    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'var(--muted-text-color)',
      padding: '3px 3px 3px 0px',
      "svg": {
          width: '14px',
          height: '14px',
      }
      }),


    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
      }),
    
    indicatorsContainer: (provided) => ({
      ...provided,
    }),

    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      let backgroundColor;
      let color;
      let cursor = isDisabled ? 'not-allowed' : 'pointer';
  
      if (isDisabled) {
        backgroundColor = undefined;
        color = '#ccc';
      } else if (isSelected) {
       // backgroundColor = data.color;
        backgroundColor = '#f1f1f1';
        color = undefined;
      } else if (isFocused) { 
        backgroundColor = '#f1f1f1';
        color = data.color;
      } else {
        backgroundColor = undefined;
        color = data.color;
      }
  
      let activeBackgroundColor;
      if (!isDisabled) {
        if (isSelected) {
          activeBackgroundColor = data.color;
        } else { 
          activeBackgroundColor = '#fff';
        }
      }
  
      return {
        ...styles,
        fontSize: '12px',
        padding: '5px 8px',
        alignItems: 'center',
        color: 'var(--text-color)', 
        display: 'flex', 
        ':before': { 
          backgroundColor: isSelected ? data.color : color, // This line is modified
          borderRadius: 10,
          content: '" "',
          display: 'block',
          marginRight: 8,
          height: 10,
          width: 10,
        },
        backgroundColor: backgroundColor, 
        cursor: cursor,
        ':active': {
          ...styles[':active'],
          backgroundColor: backgroundColor,
        },
      };
    },
    input: (styles) => ({ 
      ...styles, 
      ...dot(), 
      fontSize: '12px'
    }),

    valueContainer: (styles) => ({
      ...styles,
      padding: "1px",  
    }),


    placeholder: (styles) => ({ ...styles, ...dot('#ccc') }), 
    singleValue: (styles, { data }) => ({ ...styles, fontSize: '12px', ...dot(data.color) }),
  };


  
 
  return (
    <>  

        <Select   
          styles={colourStyles}
          isSearchable={false} 
          onChange={handleChange}
          onMenuClose={handleMenuClose}
          value={options.filter(function(option) {
            return option.value === selectedOption;
          })}
          options={options}
          isDisabled={isDisabled}
        />   
  </>

);


};

export default InsuranceDropdown;